import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect } from "react";
import { observer } from "mobx-react";
import { ScannerProgress, ScannerTemplateCards, ScannerLoadingSkeleton, ScannerListItem } from ".";
import { __ } from "../../../utils";
import { useStores } from "../../../store";
import { useConfigHintText, useScannerProgress } from "../../../hooks";
import { Divider, List } from "antd";
import { ConfigHintModal, ConfigContent, BlockerNoticeNotActive } from "..";
const ScannerList = observer(()=>{
    const { scannerStore, cookieStore } = useStores();
    const { currentJob } = useScannerProgress();
    const { templatesCount, externalUrlsCount, busyExternalUrls, sortedExternalUrls, canShowResults } = scannerStore;
    const hintText = useConfigHintText("scanner");
    useEffect(()=>{
        scannerStore.fetchResultTemplates();
        scannerStore.fetchResultExternals();
        cookieStore.fetchGroups();
    }, []);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(BlockerNoticeNotActive, {
                style: {
                    margin: "10px 0 0 0"
                }
            }),
            /*#__PURE__*/ _jsxs(ConfigContent, {
                children: [
                    /*#__PURE__*/ _jsx(ScannerProgress, {}),
                    canShowResults && templatesCount > 0 && /*#__PURE__*/ _jsx(ScannerTemplateCards, {}),
                    canShowResults && externalUrlsCount > 0 && (busyExternalUrls && !sortedExternalUrls.length && currentJob === undefined ? /*#__PURE__*/ _jsx(ScannerLoadingSkeleton, {
                        count: externalUrlsCount
                    }) : /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx(Divider, {
                                children: __("Embeds of external URLs to be checked")
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                style: {
                                    maxWidth: 800,
                                    margin: "0px auto 20px",
                                    textAlign: "center"
                                },
                                children: /*#__PURE__*/ _jsx("p", {
                                    className: "description",
                                    children: __("You are embedding scripts, styles, iframes or similar from the following third-party servers. We currently do not have service templates for these. Therefore, you may have to create a service and/or content blocker yourself after you have assessed the situation.")
                                })
                            }),
                            /*#__PURE__*/ _jsx(List, {
                                children: sortedExternalUrls.map((item)=>/*#__PURE__*/ _jsx(ScannerListItem, {
                                        item: item
                                    }, item.data.host))
                            })
                        ]
                    })),
                    /*#__PURE__*/ _jsx("div", {
                        style: {
                            maxWidth: 800,
                            margin: "30px auto 0",
                            textAlign: "center"
                        },
                        children: hintText
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(ConfigHintModal, {
                identifier: "scanner",
                title: __("What does the scanner find?"),
                width: 900
            })
        ]
    });
});
export { ScannerList };
